import { useState } from "react";
import { Popover, MenuItem, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  fontSize: "0.875rem",
  padding: theme.spacing(1, 2),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const PopoverContent = styled("div")(({ theme }) => ({
  minWidth: 180,
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
}));

export function UserCategoryActionsPopover({ user, onMoveClick }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { elevation: 2, sx: { borderRadius: "8px", mt: 0.5 } },
        }}
      >
        <PopoverContent>
          <StyledMenuItem
            onClick={() => {
              handleClose();
              onMoveClick(user);
            }}
          >
            Move User
          </StyledMenuItem>
        </PopoverContent>
      </Popover>
    </>
  );
}